// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"8":"a6b5f3b7","36":"91ada27e","341":"792a185d","411":"f5769d5d","791":"991695a3","891":"e67813ee"}[chunkId] + ".chunk.css";
};